(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-bio-bundle-add]');
    if (!button) return;
    const ids = (button.dataset.variants || '').split(',').map(Number).filter(Boolean);
    if (!ids.length) return;
    button.disabled = true;
    const error = button.parentElement.querySelector('[data-bio-bundle-error]');
    if (error) error.hidden = true;
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
      });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add these products.');
      window.location.assign(window.routes.cart_url);
    } catch (cause) {
      if (error) { error.textContent = cause.message; error.hidden = false; }
      button.disabled = false;
    }
  });
})();
